import { createContext, ReactNode, useContext, useState } from 'react';

export type NavContextType = {
  showArrow?: boolean;
  setShowArrow?: (showArrow: boolean) => void;
  goBackExact?: string;
  setGoBackExact?: (goBackExact?: string) => void;
};

type NavContextProviderProps =  {
  children: ReactNode;
};
const NavContext = createContext<NavContextType>({});

export const useNavContext = () => {
  const context = useContext(NavContext);
  return context;
};

function NavContextProvider({
  children,
}: NavContextProviderProps) {
  const [routeCtx, setRouteCtx] = useState<NavContextType>({
    showArrow: true,
    goBackExact: undefined,
  });

  const setShowArrow = (showArrow: boolean) => {
    setRouteCtx((prev) => ({ ...prev, showArrow: showArrow }));
  };

  const setGoBackExact = (goBackExact?: string) => {
    setRouteCtx((prev) => ({ ...prev, goBackExact: goBackExact }));
  };

  const contextValue: NavContextType = {
    ...routeCtx,
    setShowArrow,
    setGoBackExact,
  };

  return (
    <NavContext.Provider value={contextValue}>
      {children}
    </NavContext.Provider>
  );
}

export default NavContextProvider;
